const languageMap = {
  "-1": "en-us",
  "-24": "en-ca",
  "-25": "fr-ca"
};
export {
  languageMap
};
